import { useFormContext } from 'react-hook-form'
import { EmailLink } from './EmailLink'
import { Text } from 'components/atoms/Text'
import { Column } from 'components/atoms/Column'
import { ResendLinkButton } from './ResendLinkButton'

interface Props {
  onSubmit: () => Promise<void>
  countdown: number
}

export const ResendLinkForm = ({ onSubmit, countdown }: Props) => {
  const { watch } = useFormContext()
  const email = watch('email')

  return (
    <>
      <Column style={{ gap: 4 }}>
        <Text color="dark" variant="body1" bold>
          We have sent a verification email with a link to:
        </Text>
        <EmailLink email={email} />
        <Text light>Please check your inbox to continue the process.</Text>
      </Column>
      <Column style={{ gap: 8 }}>
        <Text color="dark" variant="body1" bold>
          Email not received?
        </Text>
        <ResendLinkButton onSubmit={onSubmit} countdown={countdown} />
      </Column>
    </>
  )
}
